// One automatic read-only recovery per resource; never retries generation.
export const createMediaRenewal = () => {
  const used = new Set()
  const inflight = new Map()
  return async (id, load) => {
    if (inflight.has(id)) return inflight.get(id)
    if (used.has(id)) throw new Error("This media could not be loaded. Please reopen it.")
    used.add(id)
    const task = Promise.resolve().then(load).finally(() => inflight.delete(id))
    inflight.set(id, task)
    return task
  }
}
export const downloadMedia = (url, name) => {
  if (!url || !/^https?:\/\//.test(url)) throw new Error("This download is no longer available.")
  const link = document.createElement("a")
  link.href = url
  if (name) link.download = name
  link.click()
}